import BaseService from '@/services/base-service';
import LicenseModel from '@/models/license.model';
import HttpService from './http.service';

export default class LicenseService extends BaseService {
  constructor(httpService: HttpService) {
    super(httpService);
  }

  async create(model: LicenseModel): Promise<LicenseModel> {
    return (await this.httpService.post(
      LicenseModel,
      `${this.apiUrl}/licenses`,
      model
    )) as LicenseModel;
  }

  async update(model: LicenseModel): Promise<LicenseModel> {
    return (await this.httpService.put(
      LicenseModel,
      `${this.apiUrl}/licenses/${model.id}`,
      model
    )) as LicenseModel;
  }

  async getAll(): Promise<LicenseModel[]> {
    return (await this.httpService.get(LicenseModel, `${this.apiUrl}/licenses`)) as LicenseModel[];
  }

  async refreshDailyLimit(model: LicenseModel): Promise<LicenseModel> {
    return (await this.httpService.put(
      LicenseModel,
      `${this.apiUrl}/licenses/${model.id}/limits`,
      model
    )) as LicenseModel;
  }
}
